document.addEventListener(
	'DOMContentLoaded',
	function () {
		const cardImages = document.querySelectorAll('.card__image'); /* Select the card with the background image */
        
        cardImages.forEach((cardImg) => {
            /* When clicking on the image card it redirects to the link in the data-href attribute */
            cardImg.addEventListener('click', () => {
                window.location = cardImg.getAttribute('data-href');
            });
        });
	},
	false,
);